import React, {
  useState,
  useContext,
  useLayoutEffect,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { useParams, useLocation, Link } from "react-router-dom";

import {
  Map0set,
  Map1set,
  Map2set,
  Syukurendou,
  Rotate0set,
  Rotate1set,
  Rotate2set,
  Fullviewerset,
} from "./buttons";

import {
  Static2Map0set,
  Static2Map0aset,
  Static2Map1set,
  Static2Map2set,
} from "./kashikabuttons";

import { Year0set, Year1set, Year2set, Year0Takaku0set } from "./kashikabuttons";
import { Area0set, Area1set, Area2set } from "./kashikacityset";

import {
  FullviewerSet,
  ModeSet,
  Area1Set,
  Area2Set,
  ShowratioSet,
  ModalcolorSet,
  Zoomlevel1Set,
  Zoomhanrei1Set,
  Year1Set,
  Year2Set,
  RendouSet,
  SyukurenSet,
  SyosaiSet,
  StartmodalSet,
  Static2Map1Set,
  Static2Map2Set,
} from "./App";

// import data_meta1 from "./geograph/metadatas/meta_data_20260205";
// import meta_mieruka from "./mieruka/meta_mieruka_20260121";
// const data_meta = data_meta1.concat(meta_mieruka);
import { data_meta, data_meta_map } from "./importmetadata";


import { HanreiGeograph } from "./geograph/HanreiGeograph";
import { GeographHeader } from "./geograph/panels/geographHeader";
import { GeographFooter } from "./geograph/panels/geographFooter";
import { GeographTab } from "./geograph/panels/geographTab";
import { GeographTitle } from "./geograph/panels/geographTitle";
import { GeographModal } from "./geograph/panels/geographModal";

import { MierukaHeader } from "./mieruka/mierukaHeader";
import { MierukaFooter } from "./mieruka/mierukaFooter";
import { DaiproHeader } from "./daipro/daiproHeader";
import { DaiproFooter } from "./daipro/daiproFooter";
import { ModalColorset } from "./mieruka/modalColorset";

// ----------------------
// utils / hooks
// ----------------------
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

function toNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}

function getMetaByNo(no) {
  if (!no) return undefined;
  return data_meta.find((r) => String(r.no) === String(no));
}

function getModeNumber(paramsMode) {
  if (paramsMode == null) return undefined;
  const n = Number(paramsMode);
  return Number.isFinite(n) ? n : undefined;
}

// ----------------------
// Map
// ----------------------
export const Map = () => {
  const { fullviewerset, setFullviewerSet } = useContext(FullviewerSet);
  const { modeset, setModeSet } = useContext(ModeSet);
  const { startmodalset, setStartmodalSet } = useContext(StartmodalSet);

  const [showcityset, setShowcityset] = useState(false);

  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);

  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);

  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);

  const { zoomlevel1set, setZoomlevel1Set } = useContext(Zoomlevel1Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);

  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { syukurenset, setSyukurenSet } = useContext(SyukurenSet);
  const { syosaiset, setSyosaiSet } = useContext(SyosaiSet);

  const { modalcolorset, setModalcolorSet } = useContext(ModalcolorSet);
  const { showratioset, setShowratioSet } = useContext(ShowratioSet);

  const params = useParams();
  const location = useLocation();

  // 例: "_{area2}_{year1}_{year2}_{no2}" みたいな想定
  const locationsetting = useMemo(() => {
    try {
      return decodeURI(location.search || "").split("_");
    } catch (e) {
      return String(location.search || "").split("_");
    }
  }, [location.search]);

  const modeNum = useMemo(() => getModeNumber(params.mode), [params.mode]);
  const prevModeset = usePrevious(modeset);

  // meta / meta2 を安定化（findで1件）
  const meta = useMemo(() => getMetaByNo(params.no), [params.no]);
  const meta2No = locationsetting?.[4] ? locationsetting[4] : params.no;
  const meta2 = useMemo(() => getMetaByNo(meta2No), [meta2No]);

  // ----------------------
  // mode に応じた “状態同期” をここに集約
  // ----------------------
  useLayoutEffect(() => {
    if (modeNum == null) return;

    // fullviewer 判定
    const fullOn =
      modeNum === 1 || modeNum === 4 || modeNum === 5 || modeNum === 11 || modeNum === 9999999;
    setFullviewerSet(!!fullOn);

    // URL→Context 反映（共通）
    const pArea = params.area;
    const lsArea2 = locationsetting?.[1];
    const lsYear1 = locationsetting?.[2];
    const lsYear2 = locationsetting?.[3];

    const applyArea12 = () => {
      if (!pArea) return;
      setArea1Set(pArea);
      setArea2Set(lsArea2 ? lsArea2 : pArea);
    };

    const applyYearsAsNumber = () => {
      if (lsYear1) setYear1Set(toNum(lsYear1));
      if (lsYear2) setYear2Set(toNum(lsYear2));
    };

    const applyYearsSpecial07 = () => {
      // params.no=="07-01" のときだけ文字列で入れたい挙動が残っていたので維持
      if (lsYear1) setYear1Set(params.no === "07-01" ? lsYear1 : toNum(lsYear1));
      if (lsYear2) setYear2Set(params.no === "07-01" ? lsYear2 : toNum(lsYear2));
    };

    // modeごとの違いだけ switch に閉じ込める
    switch (modeNum) {
      case 1: {
        setRendouSet(false);
        setSyukurenSet(false);
        applyArea12();
        applyYearsAsNumber();
        break;
      }
      case 2: {
        applyArea12();
        applyYearsSpecial07();
        break;
      }
      case 3: {
        setRendouSet(false);
        setSyukurenSet(true);
        applyArea12();
        break;
      }
      case 4: {
        applyArea12();
        applyYearsAsNumber();
        break;
      }
      case 5: {
        // もし日本全国ではない、または、・・地方で終わっていない場合は、日本全国にする
        const isJapanAll = area1set === "日本全国";
        const isRegion = (area1set || "").endsWith("地方");
        if (!isJapanAll && !isRegion) setArea1Set("日本全国");
        break;
      }
      case 6: {
        // 典型例：meta から上書き（元コード踏襲）
        setRendouSet(true);
        setSyukurenSet(false);

        if (meta?.tenkei_city) {
          setArea1Set(meta.tenkei_city);
          setArea2Set(meta.tenkei_city);
        }
        setYear1Set(meta?.year1 || meta?.year5);
        setYear2Set(meta?.year5);

        // もともとURL反映もしていたが、最後に meta で上書きされていたので
        // “上書き前提” なら、URL反映は不要（挙動を変えたくないなら残してOK）
        break;
      }
      case 7: {
        setRendouSet(false);
        setSyukurenSet(true);

        if (meta?.tenkei_city) setArea1Set(meta.tenkei_city);
        if (meta?.tenkei_city_2) setArea2Set(meta.tenkei_city_2);

        break;
      }
      case 8: {
        applyArea12();
        applyYearsSpecial07();
        break;
      }
      case 11: {
        setRendouSet(false);
        setSyukurenSet(false);
        applyArea12();
        applyYearsAsNumber();
        break;
      }
      case 9999999: {
        applyArea12();
        applyYearsAsNumber();
        break;
      }
      default: {
        // それ以外は特に何もしない
        break;
      }
    }

    // 最後に ModeSet を確定
    setModeSet(modeNum);
  }, [modeNum]); // “mode が変わったときだけ” があなたの意図だったのでここは維持

  // ----------------------
  // Static2Map の更新（filter→find で整理）
  // ※元コードの依存配列が怪しかったので「意図に沿って」安全側に寄せる
  // ----------------------
  useLayoutEffect(() => {
    const m = getMetaByNo(params.no);
    if (m) setStatic2Map1Set(m);
  }, [params.no, setStatic2Map1Set]);

  useLayoutEffect(() => {
    const m = getMetaByNo(meta2No);
    if (m) setStatic2Map2Set(m);
  }, [meta2No, setStatic2Map2Set]);

  // ----------------------
  // UI部品（ここは “見た目維持” で最小変更）
  // ----------------------
  const ButtonMapfunc = ({ children }) => {
    return (
      <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-xs md:text-base lg:text-2xl font-extrabold text-white rounded-lg group bg-gradient-to-br from-cyan-500/50 to-blue-500/50 group-hover:from-cyan-500/50 group-hover:to-blue-500/50 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200/50 dark:focus:ring-cyan-800/50">
        <span className="relative px-2.5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md group-hover:bg-opacity-0 pointer-events-auto min-w-[15vw] sm:min-w-[10vw]">
          {children}
        </span>
      </button>
    );
  };

  const ButtonMapfuncSingle = ({ children }) => {
    return (
      <div className="text-sm md:text-base mx-2">
        <ButtonMapfunc>{children}</ButtonMapfunc>
      </div>
    );
  };

  const ButtonGroup = ({ cName, children }) => <div className={cName}>{children}</div>;

  const ButtonMapcity = ({ cName = "", cSet, children }) => {
    return (
      <div onClick={() => setShowcityset(cSet)} className="mx-2">
        <button
          className={
            "relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm md:text-2xl font-extrabold text-white rounded-lg group bg-gradient-to-br from-cyan-500/50 to-blue-500/50 group-hover:from-cyan-500/50 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800 mb-1 " +
            cName
          }
        >
          <span
            className={
              "relative px-5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md group-hover:bg-opacity-0 pointer-events-auto " +
              cName
            }
          >
            {children}
          </span>
        </button>
      </div>
    );
  };

  const Button2D = () => {
    const location = useLocation();

    // 例: /map/1/11-01/群馬県伊勢崎市
    const currentPath = location.pathname;

    // /map → /map2d に置換（先頭のみ）
    const targetPath = currentPath.replace(/^\/map/, "/map2d");

    return (
      <Link
        to={targetPath}
        className="px-3 py-2 bg-gray-800 text-white rounded-md shadow-md hover:bg-gray-700 transition"
      >
        2D表示
      </Link>
    );
  };

  // ----------------------
  // buttons レンダリングを関数に隔離
  // ----------------------
  const renderButtons = () => {
    if (!params.mode) return null;

    if (params.mode == 1) {
      return (
        <HanreiGeograph meta={meta}>
          {/* ✅ 2D起動ボタン（常に右上） */}
          {/* <div className="absolute z-[60] top-2 right-2 pointer-events-none">
            <div className="pointer-events-auto">
              <Button2D />
            </div>
          </div> */}
          {!showcityset && !showratioset && (
            <ButtonGroup cName={"pointer-events-none"}>
              <ButtonMapcity cName={"w-full"} cSet={212}>
                {params.area}
              </ButtonMapcity>

              <ButtonGroup cName={"text-sm md:text-base pointer-events-auto mx-2 text-left"}>
                <ButtonMapfunc><Year0set /></ButtonMapfunc>
                <ButtonMapfunc><Map1set /></ButtonMapfunc>
                <ButtonMapfunc><Rotate1set /></ButtonMapfunc>
              </ButtonGroup>
            </ButtonGroup>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 2) {
      return (
        <HanreiGeograph meta={meta}>
          {!showcityset && !showratioset && (
            <ButtonGroup cName={"absolute z-30 w-full pointer-events-none"}>
              <ButtonMapcity cSet={212}>{params.area}</ButtonMapcity>

              <ButtonGroup cName={"text-sm md:text-base pointer-events-none mx-2"}>
                <ButtonMapfunc><Year2set /></ButtonMapfunc>
                <ButtonMapfunc><Year1set /></ButtonMapfunc>
              </ButtonGroup>

              <ButtonMapfuncSingle><Map0set /></ButtonMapfuncSingle>
              <ButtonMapfuncSingle><Rotate0set /></ButtonMapfuncSingle>
            </ButtonGroup>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 3) {
      return (
        <HanreiGeograph meta={meta}>
          {!showcityset && !showratioset && (
            <ButtonGroup cName={"absolute z-30 w-full pointer-events-none"}>
              <ButtonGroup cName={"flex justify-center"}>
                <ButtonMapcity cSet={2}>{area2set}</ButtonMapcity>
                <ButtonMapcity cSet={1}>{area1set}</ButtonMapcity>
              </ButtonGroup>

              <ButtonGroup cName={"text-sm md:text-base pointer-events-none mx-2"}>
                <ButtonMapfunc><Year0set /></ButtonMapfunc>
              </ButtonGroup>

              <ButtonMapfuncSingle><Map0set /></ButtonMapfuncSingle>
              <ButtonMapfuncSingle><Rotate0set /></ButtonMapfuncSingle>
            </ButtonGroup>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 4) {
      return (
        <HanreiGeograph meta={meta}>
          {!showcityset && !showratioset && (
            <div className="pointer-events-none">
              <div className="">
                <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm md:text-2xl font-extrabold text-white rounded-lg group dark:text-white dark:focus:ring-cyan-800 w-full mb-1">
                  <span className="relative px-5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md w-full">
                    {params.area}
                  </span>
                </button>
              </div>

              <ButtonGroup cName={"text-sm md:text-base pointer-events-auto mx-2 text-left"}>
                <ButtonMapfunc><Year0set /></ButtonMapfunc>
                <ButtonMapfunc><Map1set /></ButtonMapfunc>
                <ButtonMapfunc><Rotate1set /></ButtonMapfunc>
              </ButtonGroup>
            </div>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 5) {
      return (
        <HanreiGeograph meta={meta}>
          {!showcityset && !showratioset && (
            <div className="pointer-events-none">
              <div className="">
                <ButtonMapcity cName={"w-full"} cSet={212}>
                  {params.area}
                </ButtonMapcity>
              </div>

              <div className="text-sm md:text-base pointer-events-auto mx-2 text-left">
                <ButtonMapfunc><Year0set /></ButtonMapfunc>
                <ButtonMapfunc><Map1set /></ButtonMapfunc>
                <ButtonMapfunc><Rotate1set /></ButtonMapfunc>
              </div>
            </div>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 6) {
      return (
        <HanreiGeograph meta={meta}>
          {!showcityset && !showratioset && (
            <div className="absolute z-30 w-full pointer-events-none">
              <div className="flex justify-center">
                <div className="pointer-events-none z-0">
                  <div className="">
                    <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm md:text-2xl font-extrabold text-white rounded-lg group dark:text-white dark:focus:ring-cyan-800 w-full mb-1">
                      <span className="relative px-5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md w-full">
                        {params.area}
                      </span>
                    </button>
                  </div>

                  <div className="text-sm md:text-base pointer-events-auto mx-2">
                    <ButtonMapfunc><Year2set /></ButtonMapfunc>
                    <ButtonMapfunc><Year1set /></ButtonMapfunc>
                  </div>
                  <div className="text-sm md:text-base mx-2">
                    <ButtonMapfunc><Map0set /></ButtonMapfunc>
                  </div>
                  <div className="text-sm md:text-base mx-2">
                    <ButtonMapfunc><Rotate0set /></ButtonMapfunc>
                  </div>
                </div>
              </div>
            </div>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 7) {
      return (
        <HanreiGeograph meta={meta}>
          {!showcityset && !showratioset && (
            <div className="absolute z-30 w-full pointer-events-none">
              <div className="flex justify-center">
                <div className="">
                  <div className="flex justify-center">
                    <div className="mx-1">
                      <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm md:text-2xl font-extrabold text-white rounded-lg group dark:text-white dark:focus:ring-cyan-800 w-full mb-1">
                        <span className="relative px-5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md w-full">
                          {meta?.tenkei_city_2}
                        </span>
                      </button>
                    </div>
                    <div className="mx-1">
                      <button className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm md:text-2xl font-extrabold text-white rounded-lg group dark:text-white dark:focus:ring-cyan-800 w-full mb-1">
                        <span className="relative px-5 py-0.5 transition-all ease-in duration-75 bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50  rounded-md w-full">
                          {meta?.tenkei_city}
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="text-sm md:text-base pointer-events-auto mx-2">
                    <ButtonMapfunc><Year0set /></ButtonMapfunc>
                  </div>
                  <div className="text-sm md:text-base mx-2">
                    <ButtonMapfunc><Map0set /></ButtonMapfunc>
                  </div>
                  <div className="text-sm md:text-base mx-2">
                    <ButtonMapfunc><Rotate0set /></ButtonMapfunc>
                  </div>
                </div>
              </div>
            </div>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 8) {
      return (
        <HanreiGeograph meta={meta} meta2={meta2}>
          {!showcityset && !showratioset && (
            <ButtonGroup cName={"absolute z-30 w-full pointer-events-none"}>
              <ButtonMapcity cSet={212}>{params.area}</ButtonMapcity>

              <ButtonGroup cName={"text-sm md:text-base pointer-events-none mx-2"}>
                <ButtonMapfunc><Year0Takaku0set /></ButtonMapfunc>
              </ButtonGroup>

              <ButtonMapfuncSingle><Map0set /></ButtonMapfuncSingle>
              <ButtonMapfuncSingle><Rotate0set /></ButtonMapfuncSingle>
            </ButtonGroup>
          )}
        </HanreiGeograph>
      );
    }

    if (params.mode == 9999999) {
      return (
        <>
          <MierukaHeader />
          <MierukaFooter metadata={meta} />
          <div className="absolute z-40">
            <ModalColorset
              metadata={static2map1set}
              show={modalcolorset}
              setShow={setModalcolorSet}
            />
          </div>
        </>
      );
    }

    if (params.mode == 7777777) {
      return (
        <>
          <DaiproHeader />
          <DaiproFooter metadata={meta} className="w-full" />
          <div className="absolute z-40">
            <ModalColorset
              metadata={static2map1set}
              show={modalcolorset}
              setShow={setModalcolorSet}
            />
          </div>
        </>
      );
    }

    if (params.mode == 7777778) {
      return (
        <>
          <DaiproHeader />
          <DaiproFooter metadata={meta} />
          <div className="absolute z-40">
            <ModalColorset
              metadata={static2map1set}
              show={modalcolorset}
              setShow={setModalcolorSet}
            />
          </div>
        </>
      );
    }

    // それ以外（元の else）
    return (
      <>
        <div className="w-5/12 absolute z-30 pointer-events-none">
          <main className="w-full flex flex-wrap my-20">
            <div className="">
              <div className="text-sm md:text-base bg-black/30 rounded-lg pointer-events-auto">
                <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                  ここにはデータはありません、、、
                  <Map1set />
                </div>
                <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                  <Static2Map1set />
                </div>
                <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                  <Rotate1set />
                </div>
              </div>
            </div>
            <div className="">
              <div className="text-sm md:text-base bg-black/30 rounded-lg pointer-events-auto">
                <div className="m-1 rounded cursor-pointer">
                  <Area1set />
                </div>
              </div>
            </div>
          </main>
        </div>

        {fullviewerset === 0 && (
          <>
            <div className="absolute z-30 w-full my-20 pointer-events-none">
              <div className="w-1/4 mx-auto">
                <div className="text-sm md:text-base bg-black/30 rounded-lg pointer-events-auto">
                  <div className="m-1 rounded cursor-pointer">
                    <Area0set />
                  </div>
                </div>
              </div>
              <div className="relative text-sm md:text-base bg-black/30 rounded-lg w-16 mx-auto pointer-events-auto">
                <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                  <Fullviewerset />
                </div>

                <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                  <Rotate0set />
                </div>
              </div>
            </div>

            <div className="absolute z-30 pointer-events-none right-0">
              <main className="w-full flex flex-wrap my-20">
                <div className="">
                  <div className="text-sm md:text-base bg-black/30 rounded-lg pointer-events-auto">
                    <div className="m-1 rounded cursor-pointer">
                      <Area2set />
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="text-sm md:text-base bg-black/30 rounded-lg pointer-events-auto">
                    <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                      <Map2set />
                    </div>
                    <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                      <Static2Map2set />
                    </div>
                    <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                      <Rotate2set />
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </>
        )}

        {fullviewerset === 1 && (
          <div className="absolute z-30 right-0 pointer-events-none">
            <div className="relative text-sm md:text-base my-20 bg-black/30 rounded-lg w-16 pointer-events-auto">
              <div className="bg-teal-100/80 p-1 md:p-2 m-1 rounded cursor-pointer">
                <Fullviewerset />
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {Number(params.mode) < 10 && (
        <>
          <GeographHeader>
            <GeographTitle meta={meta} meta2={meta2} params={params} />
            <GeographTab meta={meta} meta2={meta2} />
          </GeographHeader>
          <GeographFooter />
          <GeographModal show={showcityset} setShow={setShowcityset} />
        </>
      )}
      {renderButtons()}
    </>
  );
};
